import hunanConfig from './hunan.js'
import changshaConfig from './changsha.js'
import zhuzhouConfig from './zhuzhou.js'
import xiangtanConfig from './xiangtan.js'
import hengyangConfig from './hengyang.js'
import shaoyangConfig from './shaoyang.js'
import yueyangConfig from './yueyang.js'
import changdeConfig from './changde.js'
import zhangjiajieConfig from './zhangjiajie.js'
import yiyangConfig from './yiyang.js'
import chenzhouConfig from './chenzhou.js'
import yongzhouConfig from './yongzhou.js'
import huaihuaConfig from './huaihua.js'
import loudiConfig from './loudi.js'
import xiangxiConfig from './xiangxi.js'

// 地图配置映射
const mapConfigs = {
  '430000': hunanConfig, // 湖南省
  '430100': changshaConfig, // 长沙市
  '430200': zhuzhouConfig, // 株洲市
  '430300': xiangtanConfig, // 湘潭市
  '430400': hengyangConfig, // 衡阳市
  '430500': shaoyangConfig, // 邵阳市
  '430600': yueyangConfig, // 岳阳市
  '430700': changdeConfig, // 常德市
  '430800': zhangjiajieConfig, // 张家界市
  '430900': yiyangConfig, // 益阳市
  '431000': chenzhouConfig, // 郴州市
  '431100': yongzhouConfig, // 永州市
  '431200': huaihuaConfig, // 怀化市
  '431300': loudiConfig, // 娄底市
  '433100': xiangxiConfig, // 湘西土家族苗族自治州
}

// 根据adcode获取地图配置
export function getMapConfig(adcode) {
  return mapConfigs[adcode] || hunanConfig // 默认返回湖南省配置
}

// 获取区县/城市列表
export function getRegionList(adcode, level = 'auto') {
  // 如果是省级或者adcode为430000，返回城市列表
  if (adcode === '430000' || level === 'province') {
    return hunanConfig.cities || []
  }
  
  // 市级：优先从配置文件获取districts
  const config = mapConfigs[adcode]
  if (config && config.districts) {
    return config.districts
  }

  return []
}

// 获取所有可用的地图配置
export function getAllMapConfigs() {
  return mapConfigs
}

// 检查是否支持指定的adcode
export function isSupportedAdcode(adcode) {
  return !!mapConfigs[adcode]
}

export default {
  getMapConfig,
  getRegionList,
  getAllMapConfigs,
  isSupportedAdcode
}